export default {
  primaryFontFamily: 'Mulish, sans-serif'
}



// WEBPACK FOOTER //
// ./src/theme/fonts/index.js